import React from 'react';
import NotFoundPage from './404page'; // Adjust path if needed

// Import the logo or 404 placeholder
import llama_magnify_clay from '../../assets/images/bumpclay/llama-magnify-clay.png';

function NotFoundStudioUpload({ isSidebarOpen, toggleSidebar }) {
  // Define the data you want to pass to the NotFoundPage
  const heading1 = "Lost?";
  const heading2 = "This bump upload isn't available. Sorry about that.";
  const paragraph = "Try uploading a new video.";
  const image = llama_magnify_clay;
  const buttonText = "+ New Video";
  const buttonLink = "/bumper";

  return (
    <NotFoundPage
      // Pass the sidebar props
      isSidebarOpen={isSidebarOpen}
      toggleSidebar={toggleSidebar}

      // Pass the 404 text/image props
      heading1={heading1}
      heading2={heading2}
      paragraph={paragraph}
      image={image}

      // Pass the new button text and link props
      buttonText={buttonText}
      buttonLink={buttonLink}
    />
  );
}

export default NotFoundStudioUpload;
